/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionsResponse
 */
export interface PermissionsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionsResponse
     */
    permissions?: Array<string>;
}

/**
 * Check if a given object implements the PermissionsResponse interface.
 */
export function instanceOfPermissionsResponse(value: object): value is PermissionsResponse {
    return true;
}

export function PermissionsResponseFromJSON(json: any): PermissionsResponse {
    return PermissionsResponseFromJSONTyped(json, false);
}

export function PermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function PermissionsResponseToJSON(value?: PermissionsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'permissions': value['permissions'],
    };
}

